import { Component } from 'preact';
import { Row, Col } from 'reactstrap';

import ploneApi from 'api/PloneApi';

import PloneLink from 'components/PloneLink';

export default class StartPageView extends Component {
    constructor() {
        super();

        this.state = {
            panoramas: {}
        }
    }

    componentDidMount() {
        ploneApi.fetch("@search?portal_type=panorama&fullobjects=1")
            .then(data => {
                this.setState({
                    panoramas: data
                })
            });
    }

    render() {
        const p = this.state.panoramas;
        const panoramaElements = (!p.items) ? null : p.items.map(item => {
            return (
                <Col lg={ 12 / p.items.length }>
                    <PloneLink item={ item }>
                        <div className="panorama-banner" style={{ backgroundImage: `url(${item["panorama-image"].scales.large.download})` }}>
                            <h2>{ item.title }</h2>
                        </div>
                    </PloneLink>
                </Col>
            );
        });
        return (
             <Row>

                 { panoramaElements }
            </Row>
        );
    }
}




// WEBPACK FOOTER //
// ./components/ContentViews/StartPageView.jsx